import React from 'react'
import FacebookIcon from '@mui/icons-material/FacebookRounded'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'

export const SOCIAL_NETWORKS = [
    { aria: 'Ir para página do Facebook', href: 'https://www.facebook.com/sicoobcredisulca', Icon: () => <FacebookIcon fontSize="small"/> },
    { aria: 'Ir para perfil do Instagram', href: 'https://www.instagram.com/sicoobcredisulca/', Icon: () => <InstagramIcon fontSize="small"/> },
    { aria: 'Ir para canal do Youtube', href: 'https://www.youtube.com/channel/UCaFQVB3npNzt-5v2eO_Fpqg', Icon: () => <YouTubeIcon fontSize="small"/> }
]